<template>
  <FadeIn class="relative overflow-hidden py-8 mb-4 lg:mb-8">
    <div>
      <div v-if="content.images" class="product-images">
        <template v-for="(image, index) in content.images">
          <ImageResponsive
          v-if="index == 0"
          :data="image.directus_files_id"
          :xs="6"
          :sm="6"
          :md="4"
          :lg="4"
          :xl="4"
          classes="rounded-xl"
          />
        </template>
      </div>
      <div v-if="content.url" class="prose">
        <NuxtLink :to="$localePath(content.url)" 
        target="_blank" 
        :rel="!content.url.includes('elker.com') ? 'nofollow noopener' : ''" 
        style="text-decoration: none;"
        >
          <h2>{{ content.title }} <Icon name="gridicons:external" style="position: relative; top: -7px;left: 0px;width: 15px;height: 15px;" /></h2>
        </NuxtLink>
      </div>
      <template v-else>
        <h2>{{ content.title }}</h2>
      </template>
    </div>
    <div class="prose relative" v-interpolation v-html="useSanitize(content.content, currentLocale)"></div>    
  </FadeIn>
</template>

<script setup>
const props = defineProps({
  content: {
    type: Object,
    required: true,
  }
})

const route = useRoute()
const currentLocale = computed(() => {
  return route.path.startsWith('/nz') ? 'nz' : 'au'
})
</script>

<style lang="scss">
@import '@/assets/scss/_vars.scss';
.product-images {
  > div {
    max-width: 300px;
    @media (min-width: $breakpoint) {
      max-width: 450px;
    }
  }
}
</style>